
/**
 * Genera un token aleatorio de la longitud especificada
 * @param length Longitud del token
 * @returns Token generado
 */
export function generateToken(length: number = 32): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let token = '';
  
  // Usar crypto API si está disponible para mayor seguridad
  if (window.crypto && window.crypto.getRandomValues) {
    const values = new Uint32Array(length);
    window.crypto.getRandomValues(values);
    
    for (let i = 0; i < length; i++) {
      token += characters[values[i] % characters.length];
    }
  } else {
    // Fallback para navegadores que no soportan crypto API
    for (let i = 0; i < length; i++) {
      token += characters.charAt(Math.floor(Math.random() * characters.length));
    }
  }
  
  return token;
}

/**
 * Genera un token JWT simulado para desarrollo/demo
 * @param payload Datos a incluir en el token
 * @returns Token JWT simulado
 */
export function generateJWTMock(payload: any, expiresInMinutes: number = 60): string {
  // Crear datos para la estructura JWT
  const header = {
    alg: "HS256",
    typ: "JWT"
  };
  
  const now = Math.floor(Date.now() / 1000);
  const expires = now + (expiresInMinutes * 60);
  
  const jwtPayload = {
    ...payload,
    iat: now,
    exp: expires
  };
  
  // Encodificar partes del token (en producción se firmaría con una clave secreta)
  const encodedHeader = btoa(JSON.stringify(header));
  const encodedPayload = btoa(JSON.stringify(jwtPayload));
  
  // Simular firma (en producción, sería una firma real con HMAC o RSA)
  const mockSignature = generateToken(32);
  
  return `${encodedHeader}.${encodedPayload}.${mockSignature}`;
}

/**
 * Decodifica un token JWT simulado 
 * @param token Token JWT simulado
 * @returns Payload decodificado o null si es inválido
 */
export function decodeJWTMock(token: string): any | null {
  try {
    // Dividir el token en sus partes
    const parts = token.split('.');
    
    if (parts.length !== 3) {
      return null;
    }
    
    // Decodificar el payload
    const payload = JSON.parse(atob(parts[1]));
    
    // Verificar si el token ha expirado
    const now = Math.floor(Date.now() / 1000);
    if (payload.exp && payload.exp < now) {
      return null; // Token expirado
    }
    
    return payload;
  } catch (error) {
    console.error('Error al decodificar token:', error);
    return null;
  }
}
